import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import * as Crypto from 'crypto-js';
import { ResourcesService } from '../services/resources.service';
import { ResultService } from '../services/result.service';
// import { MatSnackBar } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AnnouncementBottomsheetComponent } from '../announcement-bottomsheet/announcement-bottomsheet.component';
import { MessagesComponent } from '../messages/messages.component';
import { ResourcesNoteComponent } from '../resources-note/resources-note.component';
import { ResourcesQuestionAnswerComponent } from '../resources-question-answer/resources-question-answer.component';
import { LogService } from '../services/log.service';
import { PaymentService } from '../services/payment.service';
import { SubResourcesBottomsheetComponent } from '../sub-resources-bottomsheet/sub-resources-bottomsheet.component';


@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ResourcesComponent implements OnInit {
  constructor (public _http: HttpClient, public dialog: MatDialog, public _paymentService: PaymentService, private _resourcesService: ResourcesService, public _result: ResultService, public router: Router, public sanitizer: DomSanitizer, public _bottomSheet: MatBottomSheet, public log: LogService) { }
  public resources;
  public filtertext = "";

  public courseArr = [];
  public topicArr = [];
  public currentDisplay = 0;
  public currentCourse;
  public currentResource;
  public currentResourceId = 0;
  public currentTopic = "";

  public downloadURL;
  public video: any = document.getElementById("forVideo");
  public video_timestamp;

  public paymentEligible: any = { control: true };

  public studentSemesters = [];
  public selected_termd_id;

  public label = "";
  public loading = false;
  public controlListVar = "nodownload";


  sortByKey (array, key) {
    return array.sort(function (a, b) {
      var x = parseInt(a[key]); var y = parseInt(b[key]);
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  ngOnInit () {
    this.log
      .addLog({
        action: "Access",
        component: "Resources",
        details: `Access Resources`,
      }).subscribe(data => { });
    this._resourcesService.getSemesters().subscribe(data => {
      this.studentSemesters = data;
      // console.log(data);
      this.selected_termd_id = this.studentSemesters[this.studentSemesters.length - 1].termd_id;

      this._paymentService.getPaymentEligibility({ key: 'resources' }).subscribe(data => {
        this.paymentEligible = data;
      });
      this.currentDisplay = 0;
      this.getResources();

    })
  }
  textVideo () {
    // console.log("djdjj")
    // console.log(this.video.currentTime);
  }

  onRightClick (event: MouseEvent) {
    event.preventDefault();
  }

  sanitize (url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  getResources () {
    let i = this.studentSemesters.findIndex(s => s.termd_id == this.selected_termd_id);
    let sem = this.studentSemesters[i];
    this.label = `${sem.name} - ${sem.category} - ${sem.tag} - ${sem.term}`;
    let form = new FormData;
    form.append("termd_id", this.selected_termd_id);

    this.loading = true;
    this._resourcesService.getResources(form).subscribe(data => {
      if (!data) return;

      // this.resources = data;
      let foundCourses = [];
      let foundTopics = [];

      let resources = [...data[0].resources, ...data[1].resources, ...data[2].resources];
      resources.map(r => {
        //filter courses
        let { co_id, s_desc, f_desc, title } = r;
        let course = { co_id, s_desc, f_desc, title };
        let checkCourse = foundCourses.findIndex(f => f.co_id == course.co_id);
        if (checkCourse < 0) {
          foundCourses.push(course);
        }

        if (!r.topic_rank) r.topic_rank = 1000;
        //filter topics
        let { topic_id, topic, topic_rank } = r;
        let topicResources = this.sortByKey(resources.filter(r => r.topic_id == topic_id), 'resource_rank');
        topicResources.map(t => {
          let filename = t.my_key.split('.mp4')[0];
          let doctoredURL = `${filename}-t-${t.resource}.edoz`;
          // console.log(filename, "TOPIC RES")
          t.downloadName = doctoredURL;
        })
        let topicObj = { topic_id, topic, topic_rank, resources: topicResources, co_id };
        let checkTopic = foundTopics.findIndex(f => f.topic_id == topicObj.topic_id);
        if (checkTopic < 0) {
          foundTopics.push(topicObj);
        }
      })
      this.courseArr = foundCourses;

      this.courseArr.map(c => {
        c['topics'] = this.sortByKey(foundTopics.filter(t => t.co_id == c.co_id), 'topic_rank');
      })

      this.loading = false;
      // console.log(this.courseArr, "COURSE ARR");
    })
  }


  firstUpdate () {
    // console.log(this.currentResource)
    // update info for notes immediately
    this.video_timestamp = "00:00";
    let noteObj: any = { video_timestamp: this.video_timestamp, resource_id: this.currentResourceId, course_id: this.currentCourse.co_id, resource_det: this.currentResource };
    this._resourcesService.noteObj.next(noteObj)

    // update info for questions immediately
    let questionObj: any = { course_id: this.currentCourse.co_id, resource_id: this.currentResourceId, resource_det: this.currentResource }
    this._resourcesService.questionObj.next(questionObj);

    // update info for subresources immediately
    let subResourcesObj: any = { course_id: this.currentCourse.co_id, resource_id: this.currentResourceId, resource_det: this.currentResource };
    this._resourcesService.subResourcesObj.next(subResourcesObj);

    // update info for announcement immediately
    let announcementObj: any = { course_id: this.currentCourse.co_id, resource_det: this.currentResource };
    this._resourcesService.announcementObj.next(announcementObj);
  }


  openCourse (co) {
    if (!this.paymentEligible.control) {
      this.dialog.open(MessagesComponent, {
        data: { for: 'payment_eligibility', message: `You need to have paid ${this.paymentEligible.value}% of the tuition to be able to access resources` }
      })

      return;
    }
    this.currentDisplay = 1;
    this.currentCourse = co;
    this.topicArr = co.topics;
    // console.log(this.topicArr)
    if (this.topicArr.length > 0) {
      // this.topicArr.map(t => {
      //   t.resources = this.sortByKey(t.resources, 'resource_rank');
      // })
      if (this.topicArr[0].resources.length > 0) {
        this.log
          .addLog({
            action: "View",
            component: "Resources",
            details: `Opened Course - ${this.currentCourse.title} - ${this.currentCourse.s_desc}`,
          }).subscribe(data => { });
        this.currentResource = this.topicArr[0].resources[0];
        this.currentResourceId = this.topicArr[0].resources[0].resource_id;
        this.currentTopic = this.topicArr[0].topic;
        this.firstUpdate()
      }
    }
  }

  backToCourse () {
    this.currentDisplay = 0;
  }

  openResource (resource, topic) {
    this.log
      .addLog({
        action: "View",
        component: "Resources",
        details: `Opened Resource - ${resource.resource} - ${topic}`,
      }).subscribe(data => { });
    this.currentResource = resource;
    this.currentResourceId = resource.resource_id;
    this.currentTopic = topic;
    this.firstUpdate();
  }

  downLoadEncryptFile () {
    let resource = this.currentResource.path;
    let encrypted = Crypto.AES.encrypt(resource, this._resourcesService.secret).toString()
    this.downloadURL = `${encrypted}.mp4`;

    if (localStorage.getItem('encs')) {
      let enc_files = JSON.parse(localStorage.getItem('encs'));
      enc_files.push(encrypted);
      localStorage.setItem('encs', JSON.stringify(enc_files));
      this.log
        .addLog({
          action: "Download",
          component: "Resources",
          details: `Download Encrypt File of resource - ${this.currentResource.resource} - ${this.currentResource.topic}`,
        }).subscribe(data => { });
    }

    // console.log("enc, ", encrypted, "url:", this.downloadURL)
  }

  watchDownloads () {
    this.router.navigate(['/home/watch-resource'])
  }

  downloadVideo () {

  }

  DownloadFile (): void {
    let downloadName = this.currentResource.downloadName;
    let path = this.currentResource.path;
    this._resourcesService.DownloadVerifyFile(path).subscribe(response => {
      this.log
        .addLog({
          action: "Download",
          component: "Resources",
          details: `Downloaded Resources - ${this.currentResource.resource} - ${this.currentResource.topic}`,
        }).subscribe(data => { });
      const a = document.createElement('a')
      const objectUrl = URL.createObjectURL(response)
      a.href = objectUrl
      a.download = downloadName;
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  onSuc (e) {
    // this.snackbar.open('Video Downloaded successfully', 'Dismiss', {
    //   duration: 3000
    // })
  }

  getVideoTimeStamp () {
    let video: any = document.getElementById("forVideo");
    let current_mins: any = Math.floor(video.currentTime / 60);
    let current_secs: any = Math.floor(video.currentTime - current_mins * 60);
    if (current_mins < 10) { current_mins = "0" + current_mins };
    if (current_secs < 10) { current_secs = "0" + current_secs };
    this.video_timestamp = `${current_mins}:${current_secs}`;
  }


  viewNote () {
    this.getVideoTimeStamp();
    this._bottomSheet.open(ResourcesNoteComponent, {
      data: { video_timestamp: this.video_timestamp, resource_id: this.currentResourceId, course_id: this.currentCourse.co_id, resource: this.currentResource.resource, topic: this.currentResource.topic, title: this.currentResource.title },
    });
  }

  viewQuestionsAnswer () {
    this._bottomSheet.open(ResourcesQuestionAnswerComponent, {
      data: { course_id: this.currentCourse.co_id, resource_id: this.currentResourceId, resource: this.currentResource.resource, topic: this.currentResource.topic, title: this.currentResource.title }
    })
  }


  // updating base on tab click
  update (e) {
    if (e == 0) {
      this.getVideoTimeStamp();
      let noteObj: any = { video_timestamp: this.video_timestamp, resource_id: this.currentResourceId, course_id: this.currentCourse.co_id };
      this._resourcesService.noteObj.next(noteObj)
    } else if (e == 1) {
      let questionObj: any = { course_id: this.currentCourse.co_id, resource_id: this.currentResourceId }
      this._resourcesService.questionObj.next(questionObj);
    } else if (e == 2) {
      let subResourcesObj: any = { course_id: this.currentCourse.co_id, resource_id: this.currentResourceId };
      this._resourcesService.subResourcesObj.next(subResourcesObj);
    } else if (e == 3) {
      let announcementObj: any = { course_id: this.currentCourse.co_id };
      this._resourcesService.announcementObj.next(announcementObj);
    }
  }

  viewSubResources () {
    this._bottomSheet.open(SubResourcesBottomsheetComponent, {
      data: { resource_id: this.currentResourceId, course_id: this.currentCourse.co_id, resource: this.currentResource.resource, topic: this.currentResource.topic, title: this.currentResource.title }
    })
  }

  viewAnnouncements () {
    this._bottomSheet.open(AnnouncementBottomsheetComponent, {
      data: { course_id: this.currentCourse.co_id, resource: this.currentResource.resource, topic: this.currentResource.topic, title: this.currentResource.title }
    })
  }
  // onSave() {
  //   let downloadName = this.currentResource.downloadName;
  //   let path = this.currentResource.path;
  //   this._http.get(`https://cors-anywhere.herokuapp.com/${path}`, {responseType: 'blob' as 'json'}).subscribe(res => {
  //     this._fileSaver.save((<any>res)._body, downloadName);
  //   });
  // }

  // onRemote(type: string, fromRemote: boolean): Observable<Response> {
  //   let downloadName = this.currentResource.downloadName;
  //   let path = this.currentResource.path;
  //   return this._http.get(`${path}`, {
  //     responseType: ResponseContentType.Blob
  //   }).map(response => {
  //     response.headers.set(downloadName, `${path}`)
  //     return response;
  //   });
  // }

}
